import { ActionReference, GameObjectReference, GameState } from "@shared/types";
import { LitElement, TemplateResult, css, html, nothing } from "lit";
import { customElement } from "lit/decorators.js";
import { getState, performAction } from "../services/routeService";
// import { unsafeHTML } from "lit-html/directives/unsafe-html";

@customElement("game-canvas")
export class GameCanvas extends LitElement {
    public static styles = css`
        .game {
            height: 100%;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: auto auto 1fr auto;
            grid-column-gap: 0px;
            grid-row-gap: 0px;
        }
        .title {
            text-align: center;
            margin-top: 10px;
        }

        .header {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex-grow: 1;
            position: relative;
            margin-top: 10px;
        }

        .header img {
            width: 90%;
            height: auto;
            image-rendering: pixelated;
        }

        .header img:nth-child(n + 2) {
            position: absolute;
        }

        .title-map {
            position: absolute;
            margin-top: 7%;
            display: flex;
            right: 9%;
        }

        .minimap {
            background-color: #fffffe;
            border: 0.5vw solid #c6c6c6;
            margin-top: 9%;
            display: flex;
            height: 30%;
            width: 15%;
            position: absolute;
            right: 4%;
        }

        .minimap img {
            width: 100%;
            height: auto;
        }

        .flexbox {
            background-color: #5b3b0a;
            border: 3px solid #b17237;
            margin-top: 10px;
            display: flex;
            position: absolute;
            top: 10%;
            right: 2%;
            height: 80%;
            width: 19%;
            border-radius: 60px;
        }

        .inventory {
            background: #c6c6c6;
            border-radius: 10px;
            /* box-shadow: 2px 2px 0px #555555, inset 4px 4px 0px #fefefe; */
            /* padding: 5px; */
            position: absolute;
            bottom: 13%;
            right: 2.5%;
            max-width: 18%;
            max-height: 26%;
        }

        .stickimg {
            position: absolute;
            top: 110px;
        }

        .torchimg {
            position: absolute;
            top: 33px;
        }

        .bottleimg {
            position: absolute;
            top: 100px;
        }

        .compassimg {
            position: absolute;
            top: 105px;
        }

        .content {
            width: 90%;
            flex-grow: 1;
            overflow: auto;
            margin-top: 10px;
            margin-left: 40px;
            padding: 0 10px;
        }

        .content p {
            margin: 0 0 10px 0;
        }

        .content p:last-of-type {
            margin: 0;
        }

        h1 {
            margin: 5px 10px;
            font-family: "VT323", monospace;
            font-size: 24px;
            color: #404040;
        }

        .slot {
            width: 90px;
            height: 90px;
            display: flex;
            justify-content: center;
            background: #8b8b8b;
            box-shadow: inset 1.5px 1.5px 0px rgba(55, 55, 55, 0.8), inset -2px -2px 0px #ffffff;
        }

        .slotSpace {
            margin: 10px 10px;
            display: flex;
            flex-wrap: wrap;
        }

        .invisible {
            visibility: hidden;
        }

        .item {
            margin: 2px;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 30px;
            height: 30px;
        }

        .item img {
            width: 28px;
        }

        .ghostItem img {
            width: 28px;
        }

        ::selection {
            background: transparent;
        }

        ::-moz-selection {
            background: transparent;
        }

        .copy {
            font-family: "VT323", monospace;
            font-size: 18px;
            width: 350px;
            display: flex;
            justify-content: flex-end;
            color: #333;
        }

        a {
            color: inherit;
            text-decoration: inherit;
        }

        .footer {
            border-radius: 10px 10px 0 0;
            background-color: #5b3b0a;
            border: 3px solid #b17237;
            margin-top: 10px;
            margin-left: 40px;
            display: flex;
            height: 105px;
            width: 90%;
        }

        .footer .buttons {
            display: flex;
            flex-direction: column;
            overflow: auto;
            padding: 10px 10px 0 10px;
        }

        .footer .button {
            background-color: #903630;
            border: 1px solid #000000;
            padding: 5px 10px;
            margin: 0 0 10px 10px;
            text-transform: uppercase;
            cursor: pointer;
            display: inline-block;
            user-select: none;
        }

        .footer .button.active,
        .footer .button:hover {
            background-color: #7a0808;
        }

        .wrapper {
            width: 970px;
            height: 320px;
            /* padding: 35px; */
            border-radius: 10px;
        }
        .wrapper .input-field {
            z-index: -999;
            opacity: 0;
            position: absolute;
        }

        .content-box {
            overflow-y: auto;
        }
        .typing-text::-webkit-scrollbar {
            width: 0;
        }
        .typing-text p {
            font-size: 21px;
            text-align: justify;
            letter-spacing: 1px;
            word-break: break-all;
        }
        .typing-text p span {
            position: relative;
        }
        .typing-text p span.correct {
            color: #56964f;
        }
        .typing-text p span.incorrect {
            color: #cb3439;
            background: #ffc0cb;
            outline: 1px solid #fff;
            border-radius: 4px;
        }
        .typing-text p span.active {
            color: #00ffea;
        }
        .typing-text p span.active:before {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            height: 2px;
            width: 100%;
            opacity: 0;
            background: #00ffea;
            animation: blink 1s ease-in-out infinite;
        }
        @keyframes blink {
            50% {
                opacity: 1;
            }
        }
        .content-box .content {
            display: flex;
            margin-top: 17px;
            padding: 12px 0;
            align-items: center;
            border-top: 1px solid #ccc;
            justify-content: space-between;
        }
        .content button {
            border: none;
            outline: none;
            width: 105px;
            padding: 8px 0;
            color: #fff;
            cursor: pointer;
            font-size: 16px;
            border-radius: 5px;
            background: #17a2b8;
            transition: transform 0.3s ease;
        }
        .content button:active {
            transform: scale(0.97);
        }
        .content .result-details {
            display: flex;
            width: calc(100% - 140px);
            justify-content: space-between;
        }
        .result-details li {
            height: 22px;
            display: flex;
            list-style: none;
            align-items: center;
        }
        .result-details li:not(:first-child) {
            padding-left: 22px;
            border-left: 1px solid #ccc;
        }
        .result-details li p {
            font-size: 19px;
        }
        .result-details li span {
            display: block;
            font-size: 20px;
            margin-left: 10px;
        }
        .result-details li:not(:first-child) span {
            font-weight: 500;
        }
        .result-details li b {
            font-weight: 500;
        }
    `;

    private roomTitle?: string;
    private roomImages?: string[];
    private contentText?: string[];
    private actionButtons?: ActionReference[];
    private gameObjectButtons?: GameObjectReference[];
    private showMiniGameBeginRoom?: boolean;
    // private startGame?: boolean;
    // public gameInProgress: boolean = false;
    private selectedActionButton?: ActionReference;
    private selectedGameObjectButtons: Set<GameObjectReference> = new Set<GameObjectReference>();
    public renderProperties?: GameRoomRenderProperties;

    public paragraphs: string[];
    public typingText?: any = document.querySelector(".typing-text p");
    public inpField: any = document.querySelector(".wrapper .input-field");
    public charIndex: number = 0;
    public GameOver?: boolean;
    

    // public isTyping: any;
    // public timeTag: any= document.querySelector(".time span b");
    // public timer!: any;
    // public maxTime = 60;
    // public timeLeft = this.maxTime;
    // public isTyping = this.charIndex = 0;

    public timer?: Timer;

    public constructor() {
        super();
        this.paragraphs = [
            " You stood by the lake, feeling scared. The dark figure stepped forward and revealed that he was the kidnapper. You don't recognize me, huh? But I was the one who helped you with your car trouble. Now it's time to finish the game. You have to disappear, like the others. You felt a shock of horror, realizing the danger you were in. With a last bit of courage, you turned and ran as fast as you could, away from the sinister figure.",
        ];
    }

    public randomParagraph(): any {
        // Picking a random paragraph
        const randIndex: number = Math.floor(Math.random() * this.paragraphs.length);
        this.paragraphs[randIndex].split("").forEach((span) => {
            const spanTag: string = `<span>${span}</span>`;
            this.typingText.innerHTML += spanTag;
        });
        this.typingText.querySelectorAll("span")[0].classList.add("active");
        //  focusing input field on keydown or click event
        document.addEventListener("keydown", () => {
            this.inpField.focus(), this.timer?.startTimer();
            if(!this.timer?.isRunning){
                this.timer?.startTimer();
            }

        });
        this.typingText.addEventListener("click", () => this.inpField.focus());
    }

    public initTyping(): void {
        const characters: any = this.typingText.querySelectorAll("span");
        const typedChar: any = this.inpField.value.split("")[this.charIndex];

        // if(!this.isTyping){
        //     this.timer =  setInterval(this.initTimer, 1000);
        //     // this.isTyping = true;
        // }
        // if user hasn't entered any character or pressed backspace
        if (typedChar === null || typedChar === undefined) {
            this.charIndex--;
            characters[this.charIndex].classList.remove("correct", "incorrect");
        } else {
            // checking if characters are typed in correctly
            if (characters[this.charIndex].innerText === typedChar) {
                //  if user typed character and shown character matched then add the
                //  correct class else add the incorrect class
                characters[this.charIndex].classList.add("correct");
            } else {
                characters[this.charIndex].classList.add("incorrect");
            }
            this.charIndex++; // increment charIndex either user typed correct or incorrect character
        }
        characters.forEach((span: { classList: { remove: (arg0: string) => any } }) =>
            span.classList.remove("active")
        );
        characters[this.charIndex].classList.add("active");
    }
    public checkMiniGameState(timer: Timer, state: GameState): void {
        timer.startTimer(); // Start de timer als dat nog niet is gebeurd
        timer.timeLeft--; // Verminder de resterende tijd met één seconde
        this.updateTimerDisplay(timer.timeLeft); // Werk de weergave van de timer bij
        this.checkTimer(timer, state); // Controleer of de timer is afgelopen
    }
    
    private checkTimer(timer: Timer, state: GameState): any {
        if (timer.timeLeft <= 0) {
            this.showMiniGameBeginRoom = false;// Zet showMiniGameBeginRoom op false wanneer de timer afloopt
            timer.stop(); // Stop de timer wanneer de tijd is verstreken
            this.GameOver = true;
           
            this.requestUpdate();
            this.updateState(state);
            // return room.examine();
    }}
    public GameLost(): TemplateResult{
        if(this.GameOver){
            return html`
             <p class= "lost">Times up. You lost. Press next to continu.</p>
        `;}
        return html``;


        }

        private updateTimerDisplay(timeLeft: number): void {
            // Zorg ervoor dat timeTag correct is gekoppeld aan het HTML-element dat de tijd weergeeft
            const timeTag: any = this.shadowRoot?.querySelector(".time span b");
            if (timeTag) {
                // Update de weergave van de tijd in de HTML
                timeTag.textContent = timeLeft.toString();
            }
        }
    

   
    
    private renderMiniGame(): TemplateResult {
        if (this.showMiniGameBeginRoom) {
            return html` <div class="wrapper">
                            <p>This is a typing speed game. Press y to start.</p> 
                       <input type="text" class="input-field" />
                    <div class="content-box">
                        <div class="typing-text">
                            <p></p>
                        </div>
                        <div class="content">
                            <ul class="result-details">
                                <li class="time">
                                    <p>Time Left:</p>
                                    <span><b>60</b>s</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="typing-text"></div>`;
        }
        return html``;
    }
    private showMap1: boolean = false;

    public connectedCallback(): void {
        super.connectedCallback();

        void this.refreshState();
    }

    private async refreshState(): Promise<void> {
        const state: GameState = await getState();

        this.updateState(state);
    }

    private updateState(state: GameState): void {
        console.log(state);
        //Reset the component
        this.roomTitle = state.roomTitle;
        this.roomImages = state.roomImages;
        this.contentText = state.text;
        this.actionButtons = state.actions;
        this.gameObjectButtons = state.objects;
        this.showMap1 = state.showMap1;

        this.selectedActionButton = undefined;
        this.selectedGameObjectButtons.clear();

        this.RenderGame();

        this.requestUpdate();
    }

    private RenderGame(): void {
        this.timer = new Timer(this.checkMiniGameState.bind(this));

        if (this.showMiniGameBeginRoom) {
            setTimeout(() => {
                this.typingText = this.shadowRoot?.querySelector(".typing-text p");
                this.inpField = this.shadowRoot?.querySelector(".wrapper .input-field");
                if (this.typingText && this.inpField) {
                    this.randomParagraph();
                    this.inpField.addEventListener("input", this.initTyping.bind(this));
                } else {
                    console.error("Failed to find typingText or inpField in the shadow DOM.");
                }
            }, 100);
        }
    }

    private async handleClickAction(button: ActionReference): Promise<void> {
        if (button.alias === "play") {
            this.showMiniGameBeginRoom = true;
            this.contentText = [];
        }
        if (button.alias === "go back") {
            this.showMiniGameBeginRoom = false;
            this.timer?.stop();
            this.GameOver = false;
          
        }
        if (button.alias === "next") {
            this.showMiniGameBeginRoom = false;
            this.timer?.stop();
            this.GameOver = false;
        }
        if (button.alias === "no") {
            this.showMiniGameBeginRoom = false;
            this.timer?.stop();
            this.GameOver = false;
        }

        if (button.needsObject) {
            this.selectedActionButton = button;
            this.selectedGameObjectButtons.clear();

            this.requestUpdate();
        } else {
            const state: any = await performAction(button.alias);

            if (state === undefined) {
                return;
            }

            this.updateState(state);
        }
    }

    private async handleClickObject(button: GameObjectReference): Promise<void> {
        if (!this.selectedActionButton) {
            return;
        }

        this.selectedGameObjectButtons.add(button);

        const state: GameState | undefined = await performAction(
            this.selectedActionButton.alias,
            [...this.selectedGameObjectButtons].map((e) => e.alias)
        );

        if (this.selectedGameObjectButtons.size >= 2) {
            this.selectedActionButton = undefined;
            this.selectedGameObjectButtons.clear();
        }

        this.requestUpdate();

        if (state === undefined) {
            return;
        }

        this.updateState(state);
    }

    protected render(): TemplateResult {
        if (this.roomTitle === "Abandoned wooden cabin") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap1()}
                    ${this.renderInventory()}
                </div>
            `;
        }
 
        if (this.roomTitle === "The forest") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap2()}
                    ${this.renderInventory()}
                </div>
            `;
        }
        if (this.roomTitle === "The maze") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap2()}
                    ${this.renderInventory()}
                </div>
            `;
        }
        if (this.roomTitle === "outside") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap2()}
                    ${this.renderInventory()}
                </div>
            `;
        }


        if (this.roomTitle === "Asylum entrance") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap3()}
                    ${this.renderInventory()}
                </div>
            `;
        }
        if (this.roomTitle === "Sleeping Chamber") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap3()}
                    ${this.renderInventory()}
                </div>
            `;
        }
        if (this.roomTitle === "Filing Cabinet") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap3()}
                    ${this.renderInventory()}
                </div>
            `;
        }
        if (this.roomTitle === "Canteen") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap3()}
                    ${this.renderInventory()}
                </div>
            `;
        }
        if (this.roomTitle === "Diary") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap3()}
                    ${this.renderInventory()}
                </div>
            `;
        }
        if (this.roomTitle === "Filing Room") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap3()}
                    ${this.renderInventory()}
                </div>
            `;
        }
        if (this.roomTitle === "Main hall") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap3()}
                    ${this.renderInventory()}
                </div>
            `;
        }
        if (this.roomTitle === "Newspaper on table") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap3()}
                    ${this.renderInventory()}
                </div>
            `;
        }
        if (this.roomTitle === "Safe") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap3()}
                    ${this.renderInventory()}
                </div>
            `;
        }

        if (this.roomTitle === "A silent dark lake with a full moon") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap4()}
                    ${this.renderInventory()} ${this.GameLost()}${this.renderMiniGame()}
                </div>
            `;
        }
        if (this.roomTitle === "The End") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap4()}
                    ${this.renderInventory()} ${this.GameLost()}${this.renderMiniGame()}
                </div>
            `;
        }
        if (this.roomTitle === "Game Over") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap4()}
                    ${this.renderInventory()} ${this.GameLost()}${this.renderMiniGame()}
                </div>
            `;
        }
        if (this.roomTitle === "Play to survive") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap4()}
                    ${this.renderInventory()} ${this.GameLost()}${this.renderMiniGame()}
                </div>
            `;
        }
        if (this.roomTitle === "You win") {
            return html`
                <div class="game">
                    ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()}
                    ${this.renderFooter()} ${this.renderFlexbox()} ${this.renderMap4()}
                    ${this.renderInventory()} ${this.GameLost()}${this.renderMiniGame()}
                </div>
            `;
        }

        return html`
            <div class="game">
             ${this.GameLost()}${this.renderMiniGame()}
                ${this.renderTitle()} ${this.renderHeader()} ${this.renderContent()} ${this.renderFooter()}
                ${this.renderFlexbox()} 
            </div>
        `;
    }
 
    private renderTitle(): TemplateResult {
        if (this.roomTitle) {
            return html`<div class="title">${this.roomTitle}</div>`;
        }

        return html`${nothing}`;
    }

    private renderHeader(): TemplateResult {
        if (this.roomImages && this.roomImages.length > 0) {
            return html`
                <div class="header">
                    ${this.roomImages?.map((url) => html`<img src="/assets/img/rooms/${url}.png" />`)}
                </div>
            `;
        }

        return html`${nothing}`;
    }

    private renderContent(): TemplateResult {
        return html`
            <div class="content">
                ${this.contentText?.map(text => this.renderColoredText(text))}
            </div>
        `;
    }
    
    private renderColoredText(text: string): TemplateResult {
        if (!text || typeof text !== "string") {
            return html``;
        }
    
        // Create a new DOMParser instance
    const parser: any = new DOMParser();

    // Parse the HTML string
    const doc: any = parser.parseFromString(text, "text/html");

    // Extract the color and content from the font element
    const fontElement: any = doc.querySelector("font");
    if (!fontElement) {
        return html`${text}`; // Return the original text if no font element found
    }

    const fontColor: any = fontElement.getAttribute("color");
    const content: any = fontElement.innerHTML;

    // Generate the HTML with the extracted color and content
    return html`<span style="color: ${fontColor}">${content}</span>`;
}
    
    private renderFlexbox(): TemplateResult {
        return html` <div class="flexbox"></div> `;
    }

    private renderMap1(): TemplateResult {
        if (this.showMap1) {
            return html`
                <div class="title-map">mini-map</div>
                <div class="minimap">
                    <img src="assets/img/rooms/room1.jpg" alt="Mini Map Image" />
                </div>
            `;
        }
        return html``;
    }

    private renderMap2(): TemplateResult {
        if (this.showMap1) {
            return html`
                <div class="title-map">mini-map</div>
                <div class="minimap">
                    <img src="assets/img/rooms/room2.jpg" alt="Mini Map Image" />
                </div>
            `;
        }
        return html``;
    }

    private renderMap3(): TemplateResult {
        if (this.showMap1) {
            return html`
                <div class="title-map">mini-map</div>
                <div class="minimap">
                    <img src="assets/img/rooms/room3.jpg" alt="Mini Map Image" />
                </div>
            `;
        }
        return html``;
    }

    private renderMap4(): TemplateResult {
        if (this.showMap1) {
            return html`
                <div class="title-map">mini-map</div>
                <div class="minimap">
                    <img src="assets/img/rooms/room4.jpg" alt="Mini Map Image" />
                </div>
            `;
        }
        return html``;
    }

    private renderInventory(): TemplateResult {
        return html`
            <div class="content">
                <div class="inventory">
                    <h1>Important items</h1>
                    <div class="slotSpace">
                        <div id="1" class="slot">
                            <img class="knifeimg" src="/assets/img/rooms/knife 2.gif" />
                        </div>

                        <div id="2" class="slot">
                            <img
                                class="compassimg"
                                src="/assets/img/rooms/compass.gif"
                                style="width: 130px; height: 130px;"
                            />
                        </div>

                        <div id="3" class="slot">
                            <img
                                class="mapimg"
                                src="/assets/img/rooms/treasure-map 2.png"
                                style="width: 80px;"
                            />
                        </div>

                        <div id="4" class="slot">
                            <img
                                class="bottleimg"
                                src="/assets/img/rooms/bottle.gif"
                                style="width: 130px; height: 120px;"
                            />
                        </div>

                        <div id="5" class="slot">
                            <img class="torchimg" src="/assets/img/rooms/Torch.gif" style="width: 110px; height: 100px;" />
                        </div>

                        <div id="6" class="slot">
                            <img
                                class="stickimg"
                                src="/assets/img/rooms/spiked-stick.png"
                                style="width: 150px; height: 130px;"
                            />
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    private renderFooter(): TemplateResult {
        return html`
            <div class="footer">
                <div class="buttons">
                    <div>
                        ${this.actionButtons?.map(
                            (button) => html`<a
                                class="button ${this.selectedActionButton === button ? "active" : ""}"
                                @click=${(): void => void this.handleClickAction(button)}
                                >${button.label}</a
                            >`
                        )}
                    </div>
                    <div>
                        ${this.selectedActionButton
                            ? this.gameObjectButtons?.map(
                                  (button) => html`<a
                                      class="button ${this.selectedGameObjectButtons.has(button)
                                          ? "active"
                                          : ""}"
                                      @click=${(): void => void this.handleClickObject(button)}
                                      >${button.name}</a
                                  >`
                              )
                            : nothing}
                    </div>
                </div>
            </div>
        `;
    }
}

export class GameRoomRenderProperties {
    public word: string;

    public constructor(word: string) {
        this.word = word;
    }
}

class Timer {
    public timeTag: any = document.querySelector(".time span b");
    public maxTime = 60;
    public timeLeft = this.maxTime;
    public isRunning:boolean = false;
    public timer?: NodeJS.Timeout | null;
    public callback: (timer:Timer) => void;

    public constructor(callback:any){
        this.callback=callback;
    }
    public stop():void{
        this.isRunning = false;
    }

    public startTimer(): void {
        if (!this.isRunning) {
            this.isRunning = true;
            this.timeLeft = this.maxTime;
            if (!this.timer) {
                console.log("this timer is null");
                this.timer = setInterval(() => {
                    this.callback(this);
                },1000);
            }
        }
    }

}
